<template>
    <section id="header">
            <h1>{{ Title }}</h1>
            <h3>{{ Tagline }}</h3>
    </section>
</template>

<script>
export default {
    name: 'HeroCaro',
    props: ['Title', 'Tagline'],
    methods: {
        changeTitle(title, tagline) {
            this.Title = title;
            this.Tagline = tagline;
        }
    },
    // data() {
        // return {
        //     Title: '',
        //     Tagline: '',
        // }
    // }
}
</script>

<style scoped>
h1 {
    margin-left: -4px;
    margin-bottom: 20px;
}

h3 {
    text-transform: uppercase;
    /* mix-blend-mode: difference; */
}

</style>